import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@stores/auth'

import Login from '@pages/Login/Login.vue'
import Main from '@pages/Main/Main.vue'

import OG from '@pages/Main/pages/OG/OG.vue'
import Target from '@pages/Main/pages/Target/Target.vue'
import Horizon from '@pages/Main/pages/Horizon/Horizon.vue'
import Modelling from '@pages/Main/pages/Modelling/Modelling.vue'

const routes = [
  {
    path: '/',
    redirect: () => {
      return '/login'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { 
      requiresAuth: false,
      title: 'Вход в систему'
    }
  },
  {
    path: '/main',
    name: 'Main',
    component: Main,
    meta: { 
      requiresAuth: true,
      title: 'Развитие АКА'
    },
    children: [
        { path: 'time', component: Horizon },
        { path: 'sat', component: OG },
        { path: 'target', component: Target },
        { path: 'modelling', component: Modelling },
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@pages/NotFound.vue'),
    meta: { 
      requiresAuth: false,
      title: 'Страница не найдена'
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

router.beforeEach((to, from) => {
  document.title = to.meta.title || 'Развитие АКА'
  //console.log(to, from)
  const authStore = useAuthStore()
  if (!authStore.isAuthenticated && to.path != '/login') {
    return{ 
      name: 'Login',
    }
  }else {
    return true
  }
 return true
})

export default router